'use client';

import type {SideMenuUserOptionsProps as Props} from './typings';

import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import constantsFactory from '@/utils/constants';
import {emit} from '@/utils/events';
import SideMenuList from './SideMenuList';
import {StyledNavigationButton, StyledSideMenuListItem, StyledUserSigninOptions} from './styles';

const {ROLES} = constantsFactory();

const SideMenuUserOptions = ({auth, handleCloseSideMenu, isActive}: Props): JSX.Element => {
  const isAuthenticated = auth.isAuthenticated();
  const isAdmin = isAuthenticated && auth.isAuthorised([ROLES.STAFF]);
  const isProvider = isAuthenticated && auth.isAuthorised([ROLES.PROVIDER]);

  if (!isAuthenticated) {
    return (
      <StyledUserSigninOptions aria-label="User sign-in options">
        <li aria-label="Log in option">
          <CtaButton
            style="secondary"
            onClick={() => {
              handleCloseSideMenu();
              emit('CLICK_ON_LOGIN');
            }}
            tabIndex={isActive ? 0 : -1}
          >
            Log in
          </CtaButton>
        </li>
        <li aria-label="Sign up option">
          <CtaButton
            style="tertiary"
            onClick={() => {
              handleCloseSideMenu();
              emit('CLICK_ON_JOIN');
            }}
            tabIndex={isActive ? 0 : -1}
          >
            Sign up
          </CtaButton>
        </li>
      </StyledUserSigninOptions>
    );
  }
  return (
    <SideMenuList
      heading={isAdmin || isProvider ? 'Management' : 'Account'}
      aria-label={`${isAdmin || isProvider ? 'Management' : 'Account'} options list`}
    >
      {isAdmin && (
        <StyledSideMenuListItem $isSubMenu aria-label="Dashboard option">
          <a href="/dashboard/" tabIndex={isActive ? 0 : -1} onClick={handleCloseSideMenu}>
            Dashboard
          </a>
        </StyledSideMenuListItem>
      )}
      {isProvider && (
        <StyledSideMenuListItem $isSubMenu aria-label="Manage my shop option">
          <a href="/manage/" tabIndex={isActive ? 0 : -1} onClick={handleCloseSideMenu}>
            Manage my shop
          </a>
        </StyledSideMenuListItem>
      )}
      <StyledSideMenuListItem aria-label="Log out option">
        <StyledNavigationButton
          aria-label="Log out"
          tabIndex={isActive ? 0 : -1}
          onClick={() => {
            handleCloseSideMenu();
            auth.logout();
          }}
        >
          Log out
        </StyledNavigationButton>
      </StyledSideMenuListItem>
    </SideMenuList>
  );
};

export default SideMenuUserOptions;
